// Helpers
import {
  fromBreakpointReference,
  sharedShadowDown,
  untilBreakpointReference,
} from 'remote-com-shared/components/HeaderNavigation/styles/shared';
import { focusVisible, whenProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${untilBreakpointReference(css`
    ${sharedTransition('box-shadow')}

    padding: var(--panelYSpace) var(--panelXSpace);
    background-color: inherit;
    box-shadow: 0 0 0 transparent;
    z-index: 1;

    ${whenProp(
      '$isOpen',
      css`
        box-shadow: ${sharedShadowDown};
      `
    )}
  `)}

  a {
    ${focusVisible(css`
      border-radius: 5px;
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.irisBlue_75};
    `)}
  }
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  min-height: 36px;

  ${fromBreakpointReference(css`
    min-height: 70px;
  `)}

  ${tabletBreakpoint(css`
    flex-direction: column;
    align-items: start;
  `)}
`;
